module.exports = __webpack_public_path__ + "img/no-image.5d5743c6.png";